module.exports = "//static.hsappstatic.net/LoginUI/static-1.16097/img/SUI_mobile.svg"